import { DownloadState } from '@repo/core'
import { RootState } from '../../../store/types'

export const operationsDownloadSelectorConfig = {
  operationsMasterListDownloadSelector: {
    getRootPath: (state: RootState): DownloadState => state.accounts.master.list.operationsDownload,
  },
}
